import { useLocation, Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { saveIntendedUrl } from '../context/AuthContext'

interface RequireAuthProps {
    allowedRoles?: string[]
}

const RequireAuth: React.FC<RequireAuthProps> = ({ allowedRoles }) => {
    const { user, isAuthenticated, isSessionExpired } = useAuth()
    const location = useLocation()

    if (isSessionExpired) {
        return <Outlet />
    }

    if (!isAuthenticated || !user) {
        saveIntendedUrl(location.pathname + location.search)
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    if (
        allowedRoles &&
        !user.roles?.some((role) => allowedRoles.includes(role))
    ) {
        return <Navigate to="/unauthorized" state={{ from: location }} replace />
    }

    return <Outlet />
}

export default RequireAuth
